import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { DEMO_STEPS, DEMO_STEP_DELAY } from './data';

export const DemoModal = ({ open, onOpenChange, onJoin }) => {
  const [step, setStep] = useState(0);

  // Restart the walkthrough each time the modal opens.
  useEffect(() => {
    if (open) setStep(0);
  }, [open]);

  // Auto-advance through the steps while the modal is open.
  useEffect(() => {
    if (!open || step >= DEMO_STEPS.length - 1) return;
    const t = setTimeout(() => setStep((s) => s + 1), DEMO_STEP_DELAY);
    return () => clearTimeout(t);
  }, [open, step]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg rounded-2xl border-border bg-background p-0 sm:max-w-lg" data-testid="demo-modal">
        <DialogHeader className="px-6 pt-6 text-left">
          <DialogTitle className="font-display text-2xl font-bold tracking-tight">How a UNWP gift unfolds</DialogTitle>
          <DialogDescription className="text-muted-foreground">
            From your first photo to a reveal they'll replay again and again.
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-[60vh] space-y-3 overflow-y-auto px-6 pb-6 pt-2">
          {DEMO_STEPS.map((s, i) => {
            const active = step >= i;
            return (
              <motion.div
                key={s.n}
                animate={{ opacity: active ? 1 : 0.4, scale: active ? 1 : 0.98 }}
                transition={{ duration: 0.4 }}
                className={`flex items-start gap-4 rounded-xl border p-4 ${active ? 'border-primary/40 bg-primary/[0.04]' : 'border-border bg-card'}`}
              >
                <div className={`flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg ${active ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'}`}>
                  <s.icon className="h-5 w-5" />
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <span className="font-display text-xs font-bold text-muted-foreground">{s.n}</span>
                    <h4 className="font-display text-base font-bold tracking-tight">{s.title}</h4>
                  </div>
                  <p className="mt-0.5 text-sm leading-relaxed text-muted-foreground">{s.body}</p>
                </div>
              </motion.div>
            );
          })}
          <div className="flex items-center justify-between pt-2">
            <Button variant="ghost" size="sm" onClick={() => setStep(0)} className="text-muted-foreground" data-testid="demo-replay">
              Replay
            </Button>
            <Button onClick={onJoin} className="rounded-full bg-primary px-5 font-semibold text-primary-foreground" data-testid="demo-join">
              Join the waitlist
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
